// TEMP - converts new company ID to old company ID
const getOldCompanyId = id => (id ? id.replace(/\D/g, '') : '')

const SB_LOGOS_URL = process.env.REACT_APP_LOGOS_URL

const getCompanyLogoUrl = companyId => {
  const oldCompanyId = getOldCompanyId(companyId)

  return `${SB_LOGOS_URL}${oldCompanyId}.jpg`
}

module.exports = { getCompanyLogoUrl }



// WEBPACK FOOTER //
// ./src/utils/routing/externalLinks.js